module.exports = __webpack_public_path__ + "img/c-09.8dbd393f.jpg";